import { React, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Classic from "./components/Classic.js";
import Deep from "./components/Deep.js";

const useStyles = makeStyles((theme) => ({
  tab: {
    margin: "10px 0px 5px 3.3%",
  },
}));

const tabStyles = makeStyles(
  {
    root: {
      minHeight: "auto",
      minWidth: "auto",
      padding: "5px 20px",
      textTransform: "capitalize",
      fontSize: "1.1rem",
    },
  },
  { name: "MuiTabs" }
);

const Classify = (props) => {
  const [value, setValue] = useState(0);
  const classes = useStyles();
  const tabClass = tabStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Tabs
        className={classes.tab}
        indicatorColor="secondary"
        value={value}
        onChange={handleChange}
        aria-label="simple tabs example"
      >
        <Tab className={tabClass.root} label="Classic" />
        <Tab className={tabClass.root} label="Deep" />
        <Tab className={tabClass.root} label="Custom" />
      </Tabs>
      {value === 0 && (
        <Classic
          onSelect={() => {
            props.onSelect("classic");
          }}
        />
      )}
      {value === 1 && (
        <Deep
          onSelect={() => {
            props.onSelect("deep");
          }}
        />
      )}
    </>
  );
};

export default Classify;
